import { render, staticRenderFns } from "./AegPolicyStakeholders.vue?vue&type=template&id=3bb42fdd"
import script from "./AegPolicyStakeholders.vue?vue&type=script&lang=js"
export * from "./AegPolicyStakeholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports